exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchBar{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:baseline;align-items:baseline;vertical-align:baseline;-ms-flex-pack:end;justify-content:flex-end}.SearchBar.-expanded{width:100%}.SearchBar .search-bar-input,.SearchBar .search-button{height:29px}.SearchBar .search-bar-input{-ms-flex:1 0 auto;flex:1 0 auto}.SearchBar .cancel-icon{cursor:pointer;color:#b9b9ba;color:var(--btnTopBarText,#b9b9ba)}", ""]);

// exports
